const NoData = ({title, description, image, width} :any) => {
    return (
        <div className="w-full flex items-center flex-wrap justify-center gap-10">
            <div className={`flex flex-col gap-4`}>
                <div className={`m-auto ${width ? `w-[${width}]` : "w-[400px]"}`}>
                    <img className="w-full" src={image} alt="no_driver_photo"/>
                </div>
                <div>
                    <h2 className="text-center text-black text-base font-semibold leading-relaxed pb-1">{title}</h2>
                    <p className="text-center text-black text-sm font-normal leading-snug pb-4">{description}</p>
                </div>
            </div>
        </div>
    )
}

export default NoData